import DetailTitle from "@/components/DetailTitle"
import styles from './index.module.scss'
import classNames from "classnames"
const HowToCite = ({ howToCite }) => {
	return (
		<div className={styles.hoeToCiteBox}>
			<DetailTitle title="How to Cite" />
			<div className={classNames(styles.copyBox)}>
				{howToCite.howToCite}
			</div>
			<p>{howToCite.statement}</p>
			<a target="_blank" href={howToCite.licenseUrl}>{howToCite.licenseUrl}</a>
			<div className={styles.imgBox}>
				{howToCite.imgPath && <img src={process.env.REACT_APP_API_AFFIX + howToCite.imgPath} />}
			</div>
		</div>
	)
}
export default HowToCite;